webpackJsonp([255811786354371],{

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_0027.6f1c7ee2.jpg";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_0866.9dfa6abc.jpg";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_1322.a5559da6.jpg";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_1506.d0289cdc.jpg";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_2827.a92170e5.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_2869.92273c5f.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_2894.c980e8ad.jpg";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3001.6d4de3d5.jpg";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3198.2988d9a1.jpg";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3584.2236909f.jpg";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3592.471f3974.jpg";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3672.767b0485.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3741.318c2fb6.jpg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3859.b7bd46bf.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3862.d726d3c3.jpg";

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3887.961195fe.jpg";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_3920.8121a811.jpg";

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_4142.c7ebbf3a.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_4307.a2b6ff89.jpg";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_4700.ac13c880.jpg";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_4722.ffe88ea6.jpg";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_4987.3ef9901d.jpg";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_5023.cfeec725.jpg";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_5167.85d71dd7.jpg";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_5180.86b87b0e.jpg";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_6070.a4950f4d.jpg";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_6097.e20f2959.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_6584.8077b8e6.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_8067.ef0f5691.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_8088.13342ceb.jpg";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_8089.bd7df156.jpg";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c1.84cc1c89.jpg";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c10.463fdafe.jpg";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c11.ab9ea5ef.jpg";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c12.682fb5ef.jpg";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c13.7f5a9f13.jpg";

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c14.2772132f.jpg";

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c15.99f4de38.jpg";

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c16.6580e5e3.jpg";

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c17.4124a48a.jpg";

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c18.24068db6.jpg";

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c19.eb492886.jpg";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c2.93200ca3.jpg";

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c20.7a7b4b0a.jpg";

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c21.dee7b578.jpg";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c22.938684d6.jpg";

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c23.ab374540.jpg";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c24.a3288afb.jpg";

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c3.d4580cbf.jpg";

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c4.8d5325a1.jpg";

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c5.ea4a7e0a.jpg";

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c6.72632b60.jpg";

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c7.51c9b8db.jpg";

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c8.60ba263c.jpg";

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/c9.0f878ccf.jpg";

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HairColorPage;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LightBox = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imagesContext = __webpack_require__(607);
	var images = imagesContext.keys().map(imagesContext);
	
	function HairColorPage() {
	  return _react2.default.createElement(
	    _LightBox.Gallery,
	    { title: 'Hair Color' },
	    images.map(function (img) {
	      return _react2.default.createElement(_LightBox.Image, { src: img });
	    })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./IMG_0027.jpg": 496,
		"./IMG_0866.jpg": 497,
		"./IMG_1322.jpg": 498,
		"./IMG_1506.jpg": 499,
		"./IMG_2827.jpg": 500,
		"./IMG_2869.jpg": 501,
		"./IMG_2894.jpg": 502,
		"./IMG_3001.jpg": 503,
		"./IMG_3198.jpg": 504,
		"./IMG_3584.jpg": 505,
		"./IMG_3592.jpg": 506,
		"./IMG_3672.jpg": 507,
		"./IMG_3741.jpg": 508,
		"./IMG_3859.jpg": 509,
		"./IMG_3862.jpg": 510,
		"./IMG_3887.jpg": 511,
		"./IMG_3920.jpg": 512,
		"./IMG_4142.jpg": 513,
		"./IMG_4307.jpg": 514,
		"./IMG_4700.jpg": 515,
		"./IMG_4722.jpg": 516,
		"./IMG_4987.jpg": 517,
		"./IMG_5023.jpg": 518,
		"./IMG_5167.jpg": 519,
		"./IMG_5180.jpg": 520,
		"./IMG_6070.jpg": 521,
		"./IMG_6097.jpg": 522,
		"./IMG_6584.jpg": 523,
		"./IMG_8067.jpg": 524,
		"./IMG_8088.jpg": 525,
		"./IMG_8089.jpg": 526,
		"./c1.jpg": 527,
		"./c10.jpg": 528,
		"./c11.jpg": 529,
		"./c12.jpg": 530,
		"./c13.jpg": 531,
		"./c14.jpg": 532,
		"./c15.jpg": 533,
		"./c16.jpg": 534,
		"./c17.jpg": 535,
		"./c18.jpg": 536,
		"./c19.jpg": 537,
		"./c2.jpg": 538,
		"./c20.jpg": 539,
		"./c21.jpg": 540,
		"./c22.jpg": 541,
		"./c23.jpg": 542,
		"./c24.jpg": 543,
		"./c3.jpg": 544,
		"./c4.jpg": 545,
		"./c5.jpg": 546,
		"./c6.jpg": 547,
		"./c7.jpg": 548,
		"./c8.jpg": 549,
		"./c9.jpg": 550
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 607;


/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hair-color-js-37d009ff2943b8e18faf.js